import { downgradeInjectable } from '@angular/upgrade/static';
import * as angular from 'angular';

import { NgxTaskService } from './task.service';

export const ngxTaskServiceModule = angular.module('ngxTaskServiceModule', [])
	.factory('taskService', downgradeInjectable(NgxTaskService))
	.name;
